import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\MessageText\GetMessageTextByIdController::__invoke
* @see app/Http/Controllers/MessageText/GetMessageTextByIdController.php
* @route '/api/message-text/{message_text}'
*/
const GetMessageTextByIdController = (args: { message_text: string | number | { id: string | number } } | [message_text: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetMessageTextByIdController.url(args, options),
    method: 'get',
})

GetMessageTextByIdController.definition = {
    methods: ["get","head"],
    url: '/api/message-text/{message_text}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\MessageText\GetMessageTextByIdController::__invoke
* @see app/Http/Controllers/MessageText/GetMessageTextByIdController.php
* @route '/api/message-text/{message_text}'
*/
GetMessageTextByIdController.url = (args: { message_text: string | number | { id: string | number } } | [message_text: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { message_text: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { message_text: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            message_text: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        message_text: typeof args.message_text === 'object'
        ? args.message_text.id
        : args.message_text,
    }

    return GetMessageTextByIdController.definition.url
            .replace('{message_text}', parsedArgs.message_text.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\MessageText\GetMessageTextByIdController::__invoke
* @see app/Http/Controllers/MessageText/GetMessageTextByIdController.php
* @route '/api/message-text/{message_text}'
*/
GetMessageTextByIdController.get = (args: { message_text: string | number | { id: string | number } } | [message_text: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetMessageTextByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\MessageText\GetMessageTextByIdController::__invoke
* @see app/Http/Controllers/MessageText/GetMessageTextByIdController.php
* @route '/api/message-text/{message_text}'
*/
GetMessageTextByIdController.head = (args: { message_text: string | number | { id: string | number } } | [message_text: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetMessageTextByIdController.url(args, options),
    method: 'head',
})

export default GetMessageTextByIdController